import dayjs from 'dayjs';
export class ViewModel {
    constructor(object) {
        this.toDate = (strDate) => {
            if (strDate) {
                return dayjs(strDate);
            }
        };
        this.toDateText = (strDate) => {
            if (strDate) {
                return dayjs(strDate).format('YYYY/MM/DD');
            }
            else {
                return '-';
            }
        };
        this.toDateTimeText = (strDate) => {
            if (strDate) {
                return dayjs(strDate).format('YYYY/MM/DD HH:mm');
            }
            else {
                return '-';
            }
        };
        this.createdAtText = () => {
            return this.toDateTimeText(this.object.createdAt);
        };
        this.createDate = () => {
            return this.toDateText(this.object.createdAt);
        };
        this.updateDate = () => {
            return this.toDateText(this.object.updatedAt);
        };
        this.object = object;
    }
}
//# sourceMappingURL=index.js.map